/* eslint import/prefer-default-export: 0 */

/**
 * The status of the cart.
 */
export const CartStatus = {
  /** Cancelled or expired */
  CANCELLED: "CANCELLED",
  /** Validated / paid, cannot be changed */
  VALIDATED: "VALIDATED",
  /** Waiting to be complete, in progress */
  WAITING: "WAITING",
};

/**
 * The cart different steps ordered according to the flow.
 */
export const CartSteps = {
  CART: 1,
  CART_PAYMENT: 2,
  CART_INFORMATION: 3,
  CART_CUSTOMER_FORM: 4,
  CART_FORM: 5,
};
